export default function attachOnSelectChangeUrlHandler(selector) {
  for (let element of document.querySelectorAll(selector)) {
    element.addEventListener('change', (evt) => {
      let newQueryString = element.options[element.selectedIndex].getAttribute('data-url');
      let actualUrlWithoutQueryString = [location.protocol, '//', location.host, location.pathname].join('');
      window.location = actualUrlWithoutQueryString + newQueryString;
    });
  }
}